/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_HomeInputs */

const en_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const ar_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرئيسية`)
};

const bn_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হোম`)
};

const de_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startseite`)
};

const es_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const fr_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accueil`)
};

const pt_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página inicial`)
};

const zh_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主页`)
};

const tr_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana Sayfa`)
};

const ru_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главная страница`)
};

const pl_error_home = /** @type {(inputs: Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona główna`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Error_HomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_home = /** @type {((inputs?: Error_HomeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_HomeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_error_home(inputs)
	if (locale === "bn") return bn_error_home(inputs)
	if (locale === "de") return de_error_home(inputs)
	if (locale === "es") return es_error_home(inputs)
	if (locale === "fr") return fr_error_home(inputs)
	if (locale === "pt") return pt_error_home(inputs)
	if (locale === "zh") return zh_error_home(inputs)
	if (locale === "tr") return tr_error_home(inputs)
	if (locale === "ru") return ru_error_home(inputs)
	if (locale === "pl") return pl_error_home(inputs)
	return en_error_home(inputs)
});